/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * テンプレート詳細
 * @export
 * @interface TemplateDetail
 */
export interface TemplateDetail {
    /**
     * プレスリリースの目的ID
     * @type {number}
     * @memberof TemplateDetail
     */
    purposeId: number;
    /**
     * カテゴリ名
     * @type {string}
     * @memberof TemplateDetail
     */
    categoryName: string;
    /**
     * 配信目的名
     * @type {string}
     * @memberof TemplateDetail
     */
    purposeName: string;
    /**
     * テンプレートID
     * @type {number}
     * @memberof TemplateDetail
     */
    templateId: number;
    /**
     * タイトル
     * @type {string}
     * @memberof TemplateDetail
     */
    title: string;
    /**
     * サブタイトル
     * @type {string}
     * @memberof TemplateDetail
     */
    subtitle: string;
    /**
     * 本文。PR Editorと同じ構造のHTMLが返る。
     * @type {string}
     * @memberof TemplateDetail
     */
    text: string;
}

export function TemplateDetailFromJSON(json: any): TemplateDetail {
    return TemplateDetailFromJSONTyped(json, false);
}

export function TemplateDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplateDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'purposeId': json['purpose_id'],
        'categoryName': json['category_name'],
        'purposeName': json['purpose_name'],
        'templateId': json['template_id'],
        'title': json['title'],
        'subtitle': json['subtitle'],
        'text': json['text'],
    };
}

export function TemplateDetailToJSON(value?: TemplateDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'purpose_id': value.purposeId,
        'category_name': value.categoryName,
        'purpose_name': value.purposeName,
        'template_id': value.templateId,
        'title': value.title,
        'subtitle': value.subtitle,
        'text': value.text,
    };
}

